export default __webpack_public_path__ + "assets/models/04c40d7bd614bb022b62dc67933ed8e9.glb";